import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthService } from '@service/auth.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-switch-accounts',
    templateUrl: './switch-accounts.component.html',
    styleUrls: ['./switch-accounts.component.scss'],
    standalone: false
})
export class SwitchAccountsComponent implements OnDestroy, OnInit {
    @Output() showPasswordOverlay = new EventEmitter<string>();

    visible: boolean = false;
    roleTypeArray: { role: string }[];
    currentUserType: string = '';
    currentUserSubscription: Subscription;
    userListUpdatedSubscription: Subscription;

    constructor(private authService: AuthService) {}

    async ngOnInit(): Promise<void> {
        this.currentUserSubscription = this.authService.currentUser$.subscribe((result) => {
            this.currentUserType = result.userRoleType;
        });

        this.userListUpdatedSubscription = this.authService.userListUpdated$.subscribe(async () => {
            this.roleTypeArray = await this.authService.getUserRoles();
        });
        this.roleTypeArray = await this.authService.getUserRoles();
    }

    ngOnDestroy(): void {
        this.currentUserSubscription?.unsubscribe();
        this.userListUpdatedSubscription?.unsubscribe();
    }

    public onSelectedRole(event: string) {
        this.showPasswordOverlay.emit(event);
    }

    public setVisible() {
        this.visible = !this.visible;
    }

    onSignOutClick() {
        this.authService.signOut();
        this.visible = false;
    }

    public closePanel() {
        if (this.visible) {
            this.visible = false;
        }
    }
}
